import React, { useState, useEffect } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import PropTypes from 'prop-types';
import { FiInfo } from 'react-icons/fi';
import { isEmpty } from 'lodash';
import Model from '../monitoring/Model';
import Select from 'react-select';
import { toast } from 'react-toastify';
import ChartBody from '../table-data/ChartBody';

function SelectiveChart({ data, title }) {
  const [showModal, setShowModal] = useState(false);
  const [selectedYears, setSelectedYears] = useState([
    { value: data.variant[0], label: data.variant[0] }
  ]);
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (!isEmpty(selectedYears)) {
      prepareChartData();
    }
  }, [selectedYears]);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleYearChange = selectedOptions => {
    if (selectedOptions.length <= 3) {
      setSelectedYears(selectedOptions);
    } else {
      toast.error('You can select only 3 years.');
    }
  };

  const prepareChartData = () => {
    const series = ['SoC_Min', 'SoC_Max', 'Temperature'];
    const preparedData = {
      series: series.map(name => ({ name, data: [] })),
      date: []
    };

    selectedYears.forEach(year => {
      const yearData = data.data[year.value];
      yearData.series.forEach((month, index) => {
        preparedData.date.push(`${month} ${year.value}`);
        series.forEach(serieName => {
          const value = yearData.values[index][serieName];
          const serieIndex = preparedData.series.findIndex(
            s => s.name === serieName
          );
          preparedData.series[serieIndex].data.push(value);
        });
      });
    });

    setChartData(preparedData);
  };

  const yearOptions = data.variant.map(year => ({
    value: year,
    label: year
  }));

  // console.log(data.description, 'data.description');
  return (
    <Card className="h-100">
      <FalconCardHeader
        title={data.label}
        titleTag="h5"
        light={true}
        infoBtn={
          !isEmpty(data.description) && <FiInfo onClick={handleShowModal} />
        }
      />
      <Card.Body className="h-100 px-3 pt-0" dir="ltr">
        <Row className="d-flex py-2 pb-3 justify-content-end align-item-end">
          <Col lg={3}>
            <Form.Group controlId="yearSelect">
              <Form.Label>Select Years</Form.Label>
              <Select
                isMulti
                value={selectedYears}
                onChange={handleYearChange}
                options={yearOptions}
                closeMenuOnSelect={false}
              />
            </Form.Group>
          </Col>
        </Row>

        <p className="units-text">{data.unit}</p>
        {chartData && <ChartBody landCoverChartData={chartData} />}
      </Card.Body>
      <Model
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        description={data.description}
        title={data.label}
      />
    </Card>
  );
}

SelectiveChart.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string,
    info: PropTypes.string,
    description: PropTypes.object,
    unit: PropTypes.string,
    variant: PropTypes.arrayOf(PropTypes.string),
    data: PropTypes.object.isRequired
  }).isRequired,
  title: PropTypes.string
};

export default SelectiveChart;
